module.exports = __webpack_public_path__ + "static/img/oneyear.bba8a548.png";